import { matchPath } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Switch } from 'react-router-dom';
import { React } from 'libs/react';
import { TransitionItem } from './Transition';
import './Switcher.scss';
/**
 * @component Switcher
 * @since 1.0.0
 */
export function Switcher(props) {
    const { name } = props;
    const location = useLocation();
    const urlParams = new URLSearchParams(location.search);
    const redirect = urlParams.get('redirect');
    if (redirect) {
        location.pathname = redirect;
    }
    return (
    // <Transition
    //   presentClassName="screen--present"
    //   dismissClassName="screen--dismiss"
    // >
    React.createElement(TransitionItem, { key: getLocationKey(props.children, location.pathname) },
        React.createElement(Switch, { location: location }, props.children))
    //  </Transition>
    );
}
/**
 * @function getLocationKey
 * @since 1.0.0
 * @hidden
 */
function getLocationKey(children, pathname) {
    let found = false;
    let value = '/';
    React.Children.forEach(children, (child) => {
        if (found == false) {
            const match = matchPath(pathname, child.props);
            if (match == null) {
                return;
            }
            found = true;
            value = child.props.path;
        }
    });
    return value;
}
